import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer'
import { Button, Modal, Paper } from '@material-ui/core';
import { translate } from 'react-i18next';
import './IdleTimer.scss'

const IDLE_TIME = 1000 * 60 * 15;
const LOGOUT_TIME = 1000 * 60 * 5;
const TOKEN_REFRESH_TIME = 1000 * 60 * 5;

class IdleTimerWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lastRefresh: Date.now(), // Initialize with current time to prevent immediate refresh
            openModal: false,
            currentTime: Date.now(),
            toastExpiration: 0,
            logoutTimeout: 0,
            interval: 0,
        };
        this.onAction = this.onAction.bind(this);
        this.formatSecondsInMinSec = this.formatSecondsInMinSec.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onIdle = this.onIdle.bind(this);
    }

    addLeadingZeros = (timeUnit) => (timeUnit >= 10 ? timeUnit : `0${timeUnit}`);

    formatSecondsInMinSec = (time) => {
        if (time < 0) {
            return '00:00';
        }
        const minutes = Math.floor(time / (1000 * 60));
        const seconds = Math.floor((time - (minutes * (1000 * 60))) / 1000);
        return `${this.addLeadingZeros(minutes)}:${this.addLeadingZeros(seconds)}`;
    };

    onOk = () => {
        const { logoutTimeout } = this.state;

        clearTimeout(logoutTimeout);

        this.setState({
            openModal: false,
        });
    }

    onAction = (e) => {
        const { lastRefresh } = this.state;
        const { refreshTime } = this.props;

        const tokenRefreshTime = refreshTime || TOKEN_REFRESH_TIME;
        const timeSinceLastRefresh = Date.now() - lastRefresh;

        // Only refresh if enough time has passed and we have a valid refresh function
        if (timeSinceLastRefresh > tokenRefreshTime && typeof this.props.refreshSession === 'function') {
            this.props.refreshSession();
            this.setState({
                lastRefresh: Date.now(),
            });
        }
    }

    onIdle = (e) => {
        this.setState({
            openModal: true,
            toastExpiration: Date.now() + LOGOUT_TIME,
            logoutTimeout: setTimeout(() => { this.props.redirectLogin() }, LOGOUT_TIME),
        });
    }

    componentDidMount() {
        this.setState({
            interval: setInterval(() => this.setState({ currentTime: Date.now() }), 1000),
        });
    }

    componentWillUnmount() {
        const { logoutTimeout, interval } = this.state;

        clearTimeout(logoutTimeout);
        clearInterval(interval);
    }

    render() {
        const { openModal, toastExpiration, currentTime } = this.state;
        return (
            <>
                <div style={{ position: 'fixed', height: '100vh', width: '100vw', top: 0, left: 0 }}>
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        onIdle={this.onIdle}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={IDLE_TIME}
                    />
                </div>
                <Modal
                    open={openModal}
                >
                    <Paper
                        elevation={1}
                        className="timerModal"
                    >
                        <div>
                            <div>
                                {`${this.props.t('LogoutTimer.sessionExpire')} ${this.formatSecondsInMinSec(toastExpiration - currentTime)}.`}
                            </div>
                        </div>
                        <Button variant='contained' color='primary' onClick={() => this.onOk()}>{this.props.t('LogoutTimer.stayLogin')}</Button>
                    </Paper>
                </Modal>
            </>
        );
    }
}

export default translate('common')(IdleTimerWrapper);